import React, { useState, useEffect } from 'react'
import { RadioGroup } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { isNil } from 'ramda'
import { fetchTransactionFrequenciesSize } from '../../api'
import { getUserValue, radioValueConverter } from '../utils'
import { useTranslation } from 'react-i18next'

/**
 * @param {OptionProps} list
 * @param {?string} validValue
 * @param {?boolean} isVertical
 * @param {string} label
 * @param {string} name
 * @param {?string} defaultValue
 */
const TransactionsSizeRadio = ({
  list,
  validValue,
  isVertical,
  label,
  name,
  defaultValue
}) => {
  const [value, setValue] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [{ user, form: { accId } }, dispatch] = useStore()
  const userValue = getUserValue(accId, user, name)
  const { i18n } = useTranslation()

  useEffect(() => {
    /**
     * @param {{ string: OptionsInput[] }} data
     */
    const fetchCallback = (data) => {
      dispatch({ type: 'setData', data, name: 'transactionFrequencies' })
    }
    fetchTransactionFrequenciesSize().then(fetchCallback)
  }, [name, i18n.language])

  useEffect(() => {
    const newValue = !isNil(userValue) ? radioValueConverter(userValue) : defaultValue
    if (newValue) {
      presetValue(newValue)
    }
  }, [defaultValue, name, userValue])

  const presetValue = (value) => {
    const isValid = validValue ? value === validValue : true
    setValue(value)
    setIsValid(isValid)
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
    if (name === 'transactionsSignificantSize') {
      dispatch({ type: 'setExtFieldValue', name: 'isTransactionsSizeFieldsShown', value: isValid })
    }
  }

  const onChange = ({ currentTarget: { value } }) => {
    presetValue(value)
  }

  return (
    <RadioGroup
      name={name}
      onChange={onChange}
      value={value}
      list={list}
      label={label}
      isValid={isValid}
    />
  )
}

const getExternalTransactionsSizeFields = radioButtonField => {
  const {
    list,
    i18n,
    name,
    isVertical,
    validValue,
    defaultValue,
    order
  } = radioButtonField

  return (
    <TransactionsSizeRadio
      key={name}
      list={list}
      label={`generatedField.${i18n}`}
      isVertical={isVertical}
      validValue={validValue}
      defaultValue={defaultValue}
      name={name}
      order={order}
    />
  )
}

export { TransactionsSizeRadio, getExternalTransactionsSizeFields }
